"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _legoPagelife = _interopRequireDefault(require("../../lego-pagelife"));
var _cookie = require("../../utils/cookie");
var _log = _interopRequireDefault(require("../../utils/log"));
var stackMaxLen = 2; // 访问栈的最大长度

// 跨webview访问历史跟踪
var increaseVisitStack = function increaseVisitStack(param) {
  try {
    var val = (0, _cookie.getCookie)('zzVisitStack');
    var visitStack = val ? JSON.parse(val) : [];
    if (visitStack.length === 0) {
      visitStack.push(param);
    } else {
      var last = visitStack[visitStack.length - 1];
      var lastHref = last.href;
      var href = param.href;
      if (href !== lastHref) {
        visitStack.push(param);
      } else {
        visitStack.splice(visitStack.length - 1, 1, param); // 替换,更新访问事件和访问方式
      }
    }

    if (visitStack.length > stackMaxLen) {
      visitStack = visitStack.slice(-stackMaxLen);
    }
    (0, _cookie.setCookie)({
      zzVisitStack: JSON.stringify(visitStack)
    });
  } catch (e) {
    _log.default.error("\u8DE8webview\u8BBF\u95EE\u5386\u53F2\u8DDF\u8E2A\u62A5\u9519".concat(e));
  }
};

// 更新访问栈逻辑
var visitStackTracking = function visitStackTracking() {
  _legoPagelife.default.add('onShow', increaseVisitStack);
};
var _default = visitStackTracking;
exports.default = _default;